export default __webpack_public_path__ + "static/Global-Accessibility-b76bf241d7ea0234a72a5d6125ea1446.webp";